import React, { useState } from 'react'

import type { ComponentType } from '../types/dashboard'

import { Popover, PopoverContent, PopoverTrigger } from 'src/components/Common/PopoverDialog'

import { HiPlus } from 'react-icons/hi'
import Scrollbar from 'react-smooth-scrollbar'

import { AVAILABLE_COMPONENTS, mapElementToSlotItemMap } from '../config/dashboardConfig'
import { useDashboardContext } from '../context/DashboardContext/useContext'

interface SlotActionButtonProps {
  position: 'left' | 'right' | 'top' | 'bottom'
  onClick: (componentType: ComponentType) => void
  className?: string
  disabled?: boolean
}

export const SlotActionButton: React.FC<SlotActionButtonProps> = ({ position, onClick, className = '', disabled = false }) => {
  const [open, setOpen] = useState(false)

  const positionClass = {
    left: 'left-0 -translate-x-1/2 top-1/2 -translate-y-1/2',
    right: 'right-0 translate-x-1/2 top-1/2 -translate-y-1/2',
    top: 'top-0 -translate-y-1/2 left-1/2 -translate-x-1/2',
    bottom: 'bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2'
  }

  const { elements } = useDashboardContext()
  const slotItemMap = mapElementToSlotItemMap(elements).map(({ item }) => item)
  const availableComponents = AVAILABLE_COMPONENTS.map((comp) => ({ ...comp, disabled: slotItemMap.includes(comp.type) }))

  return disabled ? null : (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={`absolute z-20 ${positionClass[position]} ${className} opacity-0 transition-opacity duration-100 focus:ring-0 group-hover:opacity-100`}
          data-position={position}
          id="slot-action-button"
        >
          <span className="bg-th-background hover:bg-th-background-secondary flex h-6 w-6 items-center justify-center rounded-full shadow-sm transition-colors">
            <HiPlus />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-48">
        <Scrollbar className="max-h-60 overflow-y-auto">
          {availableComponents.map((component) => (
            <button
              key={component.type}
              disabled={component.disabled}
              className="w-full rounded-md px-3 py-1 text-left enabled:hover:bg-th-content-secondary disabled:cursor-not-allowed disabled:opacity-50"
              onClick={() => {
                setOpen(false)
                onClick(component.type)
              }}
            >
              {component.title}
            </button>
          ))}
        </Scrollbar>
      </PopoverContent>
    </Popover>
  )
}
